<div class="hidden lg:block">
  <!-- Stats Cards -->
  <div class="px-4 mb-4">
    <app-plant-filters (filterChange)="onFilterSelectionChange($event)">
      <button
        pButton
        label="Créer une règle (avec brouillons)"
        icon="pi pi-plus"
        class="p-button-sm"
        (click)="openCreateDialog()"
        *ind4HasRole="'SED_PLUS_SUPER_USER'"
      ></button>
      <button
        pButton
        label="Créer une règle (simple)"
        icon="pi pi-plus"
        class="p-button-sm p-button-outlined"
        (click)="openSimpleCreateDialog()"
        *ind4HasRole="'SED_PLUS_SUPER_USER'"
      ></button>
    </app-plant-filters>
  </div>
  <div class="grid grid-cols-12 gap-4 mb-4 px-4">
    <div class="col-span-12 lg:col-span-6 xl:col-span-6">
      <app-active-alarms-card
        [filterPayload]="chartFilterPayload"
      ></app-active-alarms-card>
    </div>

    <div class="col-span-12 lg:col-span-6 xl:col-span-6">
      <app-failed-rules-card
        [filterPayload]="chartFilterPayload"
      ></app-failed-rules-card>
    </div>
  </div>

  <div class="px-4 mb-4">
    <app-stage-distribution-chart
      [filterPayload]="chartFilterPayload"
    ></app-stage-distribution-chart>
  </div>

  <div class="px-4">
    <div
      class="bg-white dark:bg-gray-800 rounded-t-lg border border-gray-200 dark:border-gray-700 p-1 px-3"
    >
      <div class="flex items-center justify-end gap-6">
        <div class="flex items-center gap-3">
          <button
            pButton
            label="Journal (30 jours)"
            icon="pi pi-comments"
            class="p-button-sm p-button-outlined"
            (click)="openJournalDigest()"
          ></button>
          <span class="text-sm font-medium text-gray-700 dark:text-gray-300"
            >Afficher Règles Actives</span
          >
          <p-toggleSwitch
            [(ngModel)]="showActiveRules"
            [ngModelOptions]="{ standalone: true }"
            name="showActiveRules"
            (ngModelChange)="onActiveRulesToggleChange()"
          ></p-toggleSwitch>
        </div>
        <div class="flex items-center gap-3">
          <span class="text-sm font-medium text-gray-700 dark:text-gray-300"
            >Vue Santé Équipements</span
          >
          <p-toggleSwitch
            [ngModel]="showHealthIndicator"
            [ngModelOptions]="{ standalone: true }"
            name="showHealthIndicator"
            (ngModelChange)="
              showHealthIndicator = $event; onHealthIndicatorChange()
            "
          ></p-toggleSwitch>
        </div>
      </div>
    </div>
  </div>
  <app-journal-digest-dialog
    [(visible)]="journalDigestVisible"
    [filters]="chartFilterPayload?.Filters"
  ></app-journal-digest-dialog>

  <div class="relative px-4">
    <p-table
      #criteriatable
      [value]="pagedRules"
      dataKey="uniqueId"
      [rowsPerPageOptions]="[10, 25, 50, 100]"
      [paginator]="true"
      [lazy]="true"
      (onLazyLoad)="loadData($event)"
      [showCurrentPageReport]="true"
      [rows]="fullTableState.rows"
      [sortField]="fullTableState.sortField"
      [selectionMode]="!showHealthIndicator ? 'single' : null"
      [sortOrder]="fullTableState.sortOrder"
      [first]="fullTableState.first"
      [filters]="fullTableState.filters"
      (onRowSelect)="showAlarmDetails($event)"
      currentPageReportTemplate="Éléments de {first} a {last} sur un total de {totalRecords}"
      [globalFilterFields]="['id', 'equipementUniqueId']"
      [totalRecords]="totalRecords"
      [loading]="loading$ | async"
      [showLoader]="false"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="w-[20%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>Poste technique</span>
                <p-sortIcon
                  pSortableColumn="functionalLocation"
                  field="functionalLocation"
                />
              </div>
              <div class="mt-2 w-full flex flex-row gap-1">
                <p-columnFilter
                  [showClearButton]="false"
                  type="text"
                  field="SAPDescription"
                  name="SAPDescription"
                  class="small-filter-input"
                  placeholder="Description"
                  [style]="{ width: '60%' }"
                  size="small"
                >
                </p-columnFilter>
                <p-columnFilter
                  [showClearButton]="false"
                  type="text"
                  field="SAPId"
                  name="SAPId"
                  class="small-filter-input"
                  placeholder="ID SAP"
                  [style]="{ width: '40%' }"
                  size="small"
                >
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[10%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>Contexte</span>
                <p-sortIcon pSortableColumn="context" field="context" />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  [showClearButton]="false"
                  type="text"
                  field="context"
                  name="context"
                  class="small-filter-input"
                  placeholder="Filtrer par contexte"
                  [style]="{ width: '100%' }"
                  size="small"
                >
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th style="width: 12%">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>Date / Heure de début</span>
                <p-sortIcon
                  pSortableColumn="latestAlarmStartDate"
                  field="latestAlarmStartDate"
                />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  field="latestAlarmStartDate"
                  [showMenu]="false"
                  [showClearButton]="false"
                  dataType="date"
                  matchMode="equals"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-applyFilter="filterCallback"
                  >
                    <p-datepicker
                      placeholder="Filtrer par date de l'alarme"
                      [style]="{
                        width: '100%',
                        padding: '0',
                      }"
                      [(ngModel)]="pickedDate"
                      name="pickedDate"
                      size="small"
                      showIcon
                      iconDisplay="input"
                      hourFormat="24"
                      class="text-sm"
                      [showTime]="true"
                      [hideOnDateTimeSelect]="false"
                      styleClass="text-sm p-inputtext-sm"
                    >
                      <ng-template pTemplate="footer">
                        <div class="w-full flex justify-end">
                          <button
                            pButton
                            type="button"
                            label="Save"
                            class="p-button-sm"
                            (click)="applyFilter(pickedDate)"
                          ></button>
                        </div>
                      </ng-template>
                    </p-datepicker>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[6%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>Maturité</span>
                <p-sortIcon pSortableColumn="ruleStage" field="ruleStage" />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  field="ruleStage"
                  [showMenu]="false"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [options]="stageOptions"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedStage"
                      name="selectedStage"
                      (onChange)="filter($event.value.toString())"
                      placeholder="Filtrer par maturité"
                      size="small"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[6%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>Criticité</span>
                <p-sortIcon pSortableColumn="criticality" field="criticality" />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  field="criticality"
                  [showMenu]="false"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [options]="criticalityOptions || []"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedCriticality"
                      name="selectedCriticality"
                      (onChange)="filter($event.value.toString())"
                      placeholder="Filtrer par criticité"
                      size="small"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[8%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>D.S Alarme</span>
                <div class="flex items-center gap-1">
                  <i
                    class="pi pi-info-circle text-xs"
                    pTooltip="Dépassement de seuil d'alarme"
                    tooltipPosition="top"
                  ></i>
                  <p-sortIcon
                    pSortableColumn="evaluationsAboveAlertThresholdRatio"
                    field="evaluationsAboveAlertThresholdRatio"
                  />
                </div>
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  [showClearButton]="false"
                  type="numeric"
                  field="evaluationsAboveAlertThresholdRatio"
                  name="evaluationsAboveAlertThresholdRatio"
                  class="small-filter-input"
                  placeholder="D. seuil"
                  [style]="{ width: '100%' }"
                  size="small"
                >
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[7%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>D.S Tolérance</span>
                <div class="flex items-center gap-1">
                  <i
                    class="pi pi-info-circle text-xs"
                    pTooltip="Dépassement seuil de tolérance"
                    tooltipPosition="top"
                  ></i>
                  <p-sortIcon
                    pSortableColumn="evaluationsAboveToleranceThresholdRatio"
                    field="evaluationsAboveToleranceThresholdRatio"
                  />
                </div>
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  [showClearButton]="false"
                  type="numeric"
                  field="evaluationsAboveToleranceThresholdRatio"
                  name="evaluationsAboveToleranceThresholdRatio"
                  class="small-filter-input"
                  placeholder="D.S tolérance"
                  [style]="{ width: '100%' }"
                  size="small"
                >
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[5%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>Alarm</span>
                <p-sortIcon pSortableColumn="alarm" field="alarm" />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  field="alarm"
                  [showMenu]="false"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [options]="alarmStatusOptions || []"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedStatus"
                      name="selectedStatus"
                      (onChange)="filter($event.value.toString())"
                      placeholder="Filtrer par statut"
                      size="small"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>
          <th style="width: 5%">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <span>Santé</span>
                <p-sortIcon pSortableColumn="ruleState" field="ruleState" />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto w-full"
                  field="ruleState"
                  [showMenu]="false"
                  class="column-filter-full-width"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [options]="ruleStateOptions || []"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedState"
                      name="selectedState"
                      (onChange)="filter($event.value.toString())"
                      placeholder="Filtrer par Santé"
                      size="small"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rule let-rowIndex="rowIndex">
        <ng-container *ngIf="showHealthIndicator">
          <tr *ngIf="rowIndex % fullTableState.rows === 0">
            <td colspan="12" class="p-0">
              <app-health-indicator></app-health-indicator>
            </td>
          </tr>
        </ng-container>

        <tr
          *ngIf="!showHealthIndicator"
          [pSelectableRow]="rule"
          [class.stale-activation-row]="isActivationConditionStale(rule)"
        >
          <td class="py-4 px-4 text-left normal-case">
            {{ rule?.functionalLocation?.sapDescription }} -
            {{ rule?.functionalLocation?.sapId }}
          </td>

          <td
            (mouseenter)="onRowEnter($event, rule)"
            (mousemove)="onRowMove($event)"
            (mouseleave)="onRowLeave()"
          >
            {{ rule?.context }}
          </td>
          <td>
            {{
              !rule?.latestAlarm?.startDate
                ? "Jamais déclenché"
                : (rule?.latestAlarm?.startDate | date: "dd/MM/yyyy / HH:mm:ss")
            }}
          </td>

          <td>
            <span
              class="px-4 py-1 rounded-full text-s"
              [ngClass]="{
                'text-blue-600 bg-blue-100': rule.stage === 0,
                'text-yellow-600 bg-yellow-100': rule.stage === 1,
                'text-green-600 bg-green-100': rule.stage === 2,
                'text-green-800 bg-green-200': rule.stage === 3,
              }"
            >
              {{ getStageLabel(rule?.stage) }}
            </span>
          </td>
          <td>
            <span
              class="px-4 py-1 rounded-full text-s"
              [ngClass]="{
                'text-red-600 bg-red-100':
                  (rule.criticality?.toString() | lowercase) ===
                  CriticalityLevel.Critical,
                'text-orange-600 bg-orange-100':
                  (rule.criticality?.toString() | lowercase) ===
                  CriticalityLevel.High,
                'text-yellow-600 bg-yellow-100':
                  (rule.criticality?.toString() | lowercase) ===
                  CriticalityLevel.Medium,
                'text-blue-600 bg-blue-100':
                  (rule.criticality?.toString() | lowercase) ===
                  CriticalityLevel.Low,
              }"
            >
              {{ getCriticalityLabel(rule.criticality) }}
            </span>
          </td>
          <td class="py-4 px-4 text-left normal-case">
            {{
              rule?.alertThreshold != null
                ? rule?.evaluationsAboveAlertThresholdRatio != null
                  ? (rule?.evaluationsAboveAlertThresholdRatio
                    | percent: "1.0-2")
                  : "N/A"
                : rule?.evaluationsBelowMinAlertThresholdRatio != null
                  ? (rule?.evaluationsBelowMinAlertThresholdRatio
                    | percent: "1.0-2")
                  : "N/A"
            }}
          </td>

          <td class="py-4 px-4 text-left normal-case">
            {{
              rule?.alertThreshold != null
                ? rule?.evaluationsAboveToleranceThresholdRatio != null
                  ? (rule?.evaluationsAboveToleranceThresholdRatio
                    | percent: "1.0-2")
                  : "N/A"
                : rule?.evaluationsBelowMinToleranceThresholdRatio != null
                  ? (rule?.evaluationsBelowMinToleranceThresholdRatio
                    | percent: "1.0-2")
                  : "N/A"
            }}
          </td>

          <td>
            <div class="flex items-center justify-center">
              <lucide-icon
                [name]="rule?.latestAlarm?.status ? 'bell-ring' : 'bell'"
                [style.color]="rule?.latestAlarm?.status ? 'red' : 'gray'"
                size="20"
              ></lucide-icon>
            </div>
          </td>

          <td>
            <div class="flex items-center justify-center">
              <lucide-icon
                [name]="
                  isRuleStale(rule)
                    ? 'clock'
                    : rule?.lastErrorType
                      ? 'circle-x'
                      : 'circle-check'
                "
                [style.color]="
                  isRuleStale(rule)
                    ? 'orange'
                    : rule?.lastErrorType
                      ? 'red'
                      : 'green'
                "
                size="20"
              ></lucide-icon>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr></tr>
        <tr>
          <td colspan="12" class="p-6">
            <span class="font-bold">Aucune donnée disponible.</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr *ngIf="pagedRules.length === 0">
          <td colspan="12">
            <div class="py-20 flex justify-center"></div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div
      *ngIf="loading$ | async"
      class="absolute inset-0 bg-gray-900/10 dark:bg-white/10 flex items-center justify-center z-0"
    >
      <p-progressSpinner ariaLabel="Loading"></p-progressSpinner>
    </div>
  </div>

  <p-popover
    #op
    appendTo="body"
    [dismissable]="true"
    styleClass="trend-popover"
    (onShow)="onPopoverShow()"
    (onHide)="onPopoverHide()"
  >
    <div *ngIf="trendChartData; else loading" class="w h-[100px]">
      <canvas
        baseChart
        [data]="trendChartData"
        [options]="trendChartOptions"
        [type]="'line'"
        height="100"
        width="300"
      >
      </canvas>
    </div>

    <ng-template #loading>
      <div class="loading-indicator">Chargement...</div>
    </ng-template>

    <!-- your content -->
  </p-popover>
</div>
<!-- Affichage en carte pour petits écrans -->
<div class="block lg:hidden">
  <div
    *ngFor="let rule of rules; let i = index"
    class="mb-6 border rounded-border shadow-sm overflow-hidden border-surface-300 dark:border-surface-500"
    [ngClass]="{
      'bg-white': i % 2 === 0,
      'bg-gray-50': i % 2 !== 0,
    }"
  >
    <div
      class="p-4 border-b bg-gray-100 border-surface-300 dark:border-surface-500"
    >
      <h3 class="font-bold">Alarme # {{ rule.uid }}</h3>
    </div>
    <div class="p-4">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 md:col-span-6 lg:col-span-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-6">
              <div class="text-xs font-bold text-gray-600 uppercase">
                Poste technique :
              </div>
            </div>
            <div class="col-span-6">
              <div class="text-sm">N/A</div>
            </div>
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-6">
              <div class="text-xs font-bold text-gray-600 uppercase">
                Date / Heure debut:
              </div>
            </div>
            <div class="col-span-6">
              <div class="text-sm">
                {{
                  rule?.latestAlarm?.startDate | date: "dd/MM/yyyy / HH:mm:ss"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-6">
              <div class="text-xs font-bold text-gray-600 uppercase">
                Date / Heure Fin:
              </div>
            </div>
            <div class="col-span-6">
              <div class="text-sm">
                {{
                  rule?.latestAlarm?.startDate | date: "dd/MM/yyyy / HH:mm:ss"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-6">
              <div class="text-xs font-bold text-gray-600 uppercase">
                Modèle :
              </div>
            </div>
            <div class="col-span-6">
              <div class="text-sm">N/A</div>
            </div>
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-6">
              <div class="text-xs font-bold text-gray-600 uppercase">
                Criticité :
              </div>
            </div>
            <div class="col-span-6">
              <div class="text-sm">
                <span
                  class="px-2 py-1 rounded-border text-s"
                  [ngClass]="{
                    'text-red-600 bg-red-100':
                      rule.criticality === CriticalityLevel.Critical,
                    'text-orange-600 bg-orange-100':
                      rule.criticality === CriticalityLevel.High,
                    'text-yellow-600 bg-yellow-100':
                      rule.criticality === CriticalityLevel.Medium,
                    'text-blue-600 bg-blue-100':
                      rule.criticality === CriticalityLevel.Low,
                  }"
                >
                  {{ getCriticalityLabel(rule.criticality) }} //HERE
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-6">
              <div class="text-xs font-bold text-gray-600 uppercase">
                Prédiction :
              </div>
            </div>
            <div class="col-span-6">
              <div class="text-sm">N/A</div>
            </div>
          </div>
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-4">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-6">
              <div class="text-xs font-bold text-gray-600 uppercase">
                Statut :
              </div>
            </div>
            <div class="col-span-6">
              <div class="text-sm">
                <span
                  class="font-medium"
                  [ngClass]="{
                    'text-red-600': rule?.latestAlarm?.status,
                    'text-green-600': !rule?.latestAlarm?.status,
                  }"
                >
                  {{ rule?.latestAlarm?.status ? "Active" : "Inactive" }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 text-center flex justify-end">
        <p-button size="small"> Détails </p-button>
      </div>
    </div>
  </div>
</div>
